import React, {FC} from "react";
import {EuiPage, EuiPageBody, EuiPageHeader, EuiPageSection} from "@elastic/eui";
import {Outlet} from "react-router-dom";

export const AccountingPage : FC = () => {
    return (
        <EuiPage>
            <EuiPageBody>
                <EuiPageSection>
                    <EuiPageHeader pageTitle={"Accounting"}/>
                </EuiPageSection>
                <EuiPageSection>
                    <Outlet />
                </EuiPageSection>
            </EuiPageBody>
        </EuiPage>
    )
}